import Logout from "../util/Logout";

export default function Dashboard() {
  return (
  <div>
    <h1>Dashboard Page</h1>
    <Logout/>
  </div>);
}